var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('mainHeader')],1),_c('router-view'),_c('error-message',{attrs:{"error":_vm.responseError}}),_c('div',{staticStyle:{"height":"150px"}}),_c('footer',{staticClass:"version"},[_c('mainFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }